<app-text-variations-shepherd></app-text-variations-shepherd>
<form nz-form [nzLayout]="'vertical'" [formGroup]="senderService.senderForm">
  <nz-steps nzType="navigation" nzSize="small" [nzCurrent]="senderService.tabIndex"
            (nzIndexChange)="onIndexChange($event)">
    <nz-step nzTitle="Выбор типа" [nzDisabled]="disable"></nz-step>
    <nz-step [nzTitle]="(senderService.senderType === 3 ? 'Группа' : 'Контакты')"></nz-step>
    <nz-step *ngIf="senderService.showSenderSettingsTab" nzTitle="Настройки"></nz-step>
    <!--<nz-step [nzDisabled]="true" nzTitle="Готово"></nz-step>-->
  </nz-steps>

  <div class="steps-action" *ngIf="senderService.tabIndex === 0">
    <div class="d-flex h-100 w-100 align-items-center flex-wrap">
      <nz-steps class="steps-vertical" nzSize="small" nzDirection="vertical" [nzCurrent]="senderService.senderType">
        <nz-step class="pointer order-2" (click)="selectType(0)"
                 [nzIcon]="iconTemplateDefault" [nzTitle]="nzTitleDefault"
                 nzDescription="Рассылка по списку контактов.">
          <ng-template #nzTitleDefault>
            Стандарт&nbsp;<i-feather
            nzTooltipPlacement="bottom" nz-tooltip
            nzTooltipTitle="Рассылка по группам или личные сообщения текстового сообщения с любым файлом. Используйте его, если тип Пост/сообщение Вам не подходит."
            name="info"></i-feather>
          </ng-template>
          <ng-template #iconTemplateDefault>
            <i-feather name="message-square"></i-feather>
          </ng-template>
        </nz-step>


        <nz-step (click)="selectType(1)" [nzDisabled]="false" [nzIcon]="iconTemplateUp" nzTitle="Накрутка"
                 nzDescription="Рассылка по чатам взаимных подписок." class="order-3">
          <ng-template #iconTemplateUp>
            <i-feather name="trending-up"></i-feather>
          </ng-template>
        </nz-step>

        <nz-step class="pointer order-0" (click)="selectType(2)"
                 [nzIcon]="iconTemplatePost" [nzTitle]="nzTitlePost"
                 nzDescription="Пересылка постов из каналов и групп.">
          <ng-template #iconTemplatePost>
            <i-feather name="media"></i-feather>
          </ng-template>
          <ng-template #nzTitlePost>
            Пост/сообщение&nbsp;🔥&nbsp;<i-feather
            nzTooltipPlacement="top" nz-tooltip
            nzTooltipTitle="По сравнению со стандартом банятся аккаунты реже и можно сделать в приложении телеграмм любой пост с кнопками, видео, голосовым."
            name="info"></i-feather>
          </ng-template>
        </nz-step>

        <nz-step class="pointer order-1" (click)="selectType(3)"
                 [nzIcon]="iconTemplateParsing" [nzTitle]="nzTitleParsing"
                 nzDescription="Парсинг чата и рассылка подписчикам">
          <ng-template #iconTemplateParsing>
            <i-feather name="cpu"></i-feather>
          </ng-template>
          <ng-template #nzTitleParsing>
            Парсинг&nbsp;<i-feather
            nzTooltipPlacement="top" nz-tooltip
            nzTooltipTitle="Если у вас нет готового списка получателей, первым делом вы можете спарсить канал или группу с открытым списком подписчиков."
            name="info"></i-feather>
          </ng-template>
        </nz-step>

      </nz-steps>

    </div>
  </div>
  <div class="steps-action" *ngIf="senderService.tabIndex === 1">
    <ng-template [ngIf]="senderService.senderType === 3" [ngIfElse]="contactsTextarea">
      <app-add-form-chat-step></app-add-form-chat-step>
    </ng-template>
    <ng-template #contactsTextarea>
      <div class="d-flex justify-content-between">
        <div>
          Получателей: {{senderService.senderForm.get('total_send').value}} |
          <a (click)="modalService.openModal('FaqParseComponent', {});" class="text-info text-underline pointer">где взять?</a>
        </div>
        <span *ngIf="!interfaceService.isLeadsDomain" class="badge badge-sm badge-success ml-3"> {{senderService.messagePrice}}₽/сообщение</span>
      </div>

      <nz-form-item class="">
        <!--<nz-form-label class="text-muted mb-0 d-md-flex justify-content-between">

        </nz-form-label>-->
        <nz-form-control
          [nzValidateStatus]="senderService.senderForm.value?.total_send > 0 ? 'success' : 'warning'"
          nzHasFeedback
          nzWarningTip="Укажите список получателей">
        <textarea id="sender_contacts" #messageText class="form-control" [nzAutosize]="{ minRows: 2, maxRows: 6 }"
                  formControlName="contacts" placeholder="@coscosang
@Siteguide
https://t.me/Siteguide
" rows="4" nz-input id="sender_contacts"></textarea>
          <!--<textarea #messageText class="form-control" [nzAutosize]="{ minRows: 2, maxRows: 6 }" nz-input
                    *ngIf="senderService.senderType == 2" formControlName="contacts" placeholder="+79998887766
+7 (777) 444 55 44
+7 (777)-555-55-44
+7 (777)-555-5544" rows="4"></textarea>-->

        </nz-form-control>
      </nz-form-item>
      <div class="row w-100 justify-content-between mt-0">
        <div class="col-12 col-lg line-height-normal">
          <small class="text-muted ">
            <i-feather name="info" class="mr-2 text-info"></i-feather>
            Вставьте в область выше список получателей, <b class="text-dark">каждый с новой строки</b>.<br>
            Допускаются: <b>Юзернэйм, ID (группы), Ссылка на группу/канал</b>
          </small>
        </div>
        <div class="col-12 col-lg-auto text-right px-0">
          <button
            *ngIf="senderService.senderForm.get('contacts').valid"
            (click)="onNextContacts()" nzShape="round" nzGhost nz-button nzType="primary">
            Далее
            <i-feather name="chevron-right" class="icon-md"></i-feather>
          </button>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="steps-action" *ngIf="senderService.tabIndex === 2">
    <div class="row" *ngIf="senderService.senderType === 2">
      <div class="col-12">
        <app-add-form-post-input></app-add-form-post-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md">
        <!--<nz-form-item>
          <nz-date-picker formControlName="start_date"></nz-date-picker>
        </nz-form-item>-->
        <nz-form-item>
          <nz-form-label class="text-muted mb-0">Время начала рассылки по МСК</nz-form-label>
          <nz-form-control
            [nzValidateStatus]="senderService.senderForm.get('start_date').invalid ? 'warning' : ''"
            nzHasFeedback
            nzWarningTip="Укажите время">
            <input formControlName="start_date" type="datetime-local" nz-input id="senderTime">
          </nz-form-control>
        </nz-form-item>
      </div>
      <div *ngIf="senderService.senderType !== 3" class="col-12 col-md">
        <nz-form-item>
          <nz-form-label class="text-muted mb-0">Режим повторов</nz-form-label>
          <nz-form-control>
            <nz-radio-group
              [(ngModel)]="senderService.isLoopEnable"
              [ngModelOptions]="{standalone: true}" (ngModelChange)="setLoopChange($event)"
            >
              <label placement="top" [tooltip]="helpSingleMode" nz-radio-button [nzValue]="false">
                <i-feather name="rotate-cw"></i-feather>
                Разовая
              </label>
              <label placement="top" [tooltip]="helpLoopMode" nz-radio-button [nzValue]="true">
                <i-feather name="refresh-cw"></i-feather>
                Повторяющаяся
              </label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div *ngIf="senderService.senderType != 3" class="col-12">
        <hr class="mt-0 mb-3">
        <small class="text-muted">
          <i-feather name="info" class="mr-2 text-info"></i-feather>
          {{senderService.isLoopEnable ? helpLoopMode : helpSingleMode}}
        </small>
        <div *ngIf="senderService.isLoopEnable" class="row">
          <div class="col-lg-6">
            <nz-form-item>
              <nz-form-label class="text-muted">Интервал между повторами минут</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="(!senderService.senderForm.get('loop_interval').value) ? 'warning' : ''"
                nzHasFeedback
                nzWarningTip="Заполните интервал">
                <nz-input-number formControlName="loop_interval" class="w-100" [nzMin]="15" [nzMax]="10000"
                                 [nzStep]="5"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div class="col-lg-6">
            <nz-form-item>
              <nz-form-label class="text-muted">Повторять рассылку раз</nz-form-label>
              <nz-form-control
                [nzValidateStatus]="(!senderService.senderForm.get('loop_need_count').value) ? 'warning' : ''"
                nzHasFeedback
                nzWarningTip="Укажите кол-во циклов">
                <nz-input-number formControlName="loop_need_count" class="w-100" [nzMin]="1" [nzMax]="10000"
                                 [nzStep]="1"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
          </div>

        </div>
      </div>
    </div>

    <!--<div class="d-flex w-100 justify-content-end mt-4">
      <button
        *ngIf="!senderService.senderForm.get('contacts').invalid"
        (mousemove)="allService.effectMouseMove($event)"
        (click)="onIndexChange(2)"
        type="button"
        class="effectMouse effect-white btn btn-lg btn-sm btn-basic btn-secondary d-flex align-items-center"
      >
        Дальше
        <i-feather name="chevron-right" class="icon-md"></i-feather>
      </button>
    </div>-->

  </div>

  <div class="steps-action" *ngIf="senderService.tabIndex == 3">
    <nz-result
      nzStatus="success"
      nzTitle="Рассылка успешно добавлена"
      nzSubTitle="Добавлена в список сверху и в течение 10 минут будет запушена"
    >
      <div nz-result-extra>
        <button nz-button nzType="primary">Добавить еще</button>
        <button nz-button>Закрыть</button>
      </div>
    </nz-result>
  </div>
</form>
